module.exports = __webpack_public_path__ + "static/media/part-10.c45688bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gallery/part-10.jpg
// module id = 943
// module chunks = 0